import React, { useEffect, useState } from "react";
import "./LocationDropdown.scss";
import { useTranslation } from "@me8eon/translation";
import RoomLocations from "./RoomLocations";
import useRoomBookingStore from "../../store/roomBookingStore";

function LocationDropdown() {
    const t = useTranslation("room-booking");
    const [locationQuery, setLocationQuery] = useState("");
    const clickedLocation = (
        ids: number[],
        name: string,
        closeDropDown?: boolean
    ) => {
        setCurrentLocationIds(ids);
        setClickedFloor(name);
        setLocationQuery(name || "");
        if (closeDropDown) {
            setLocationDropdownOpen(false);
        }
    };
    const {
        clickedFloor,
        setClickedFloor,
        setLocationDropdownOpen,
        setLocationDropdownError,
        locationDropdownError,
        isLocationDropdownOpen,
        setCurrentLocationIds,
        userData
    } = useRoomBookingStore();

    useEffect(() => {
        setLocationQuery(clickedFloor || "");
    }, [clickedFloor]);

    return (
        <div className="location-dropdown">
            <label className="form-label">
                {t("selectRoomLocation")}
            </label>
            <input
                type="text"
                className={`selected-location${
                    isLocationDropdownOpen ? " location-dropdown-open" : ""
                }${locationDropdownError ? " location-dropdown-error" : ""}${
                    !locationQuery?.length
                        ? " location-dropdown-placeholder"
                        : ""
                }`}
                value={locationQuery}
                placeholder="Select Location / Room"
                onClick={(event) => {
                    document.body.click();
                    event.stopPropagation();
                    setLocationDropdownError("");
                    setLocationDropdownOpen(true);
                }}
                onFocus={(event) => {
                    event.stopPropagation();
                    setLocationDropdownOpen(true);
                }}
                onChange={(event) => {
                    setLocationDropdownError("");
                    setLocationQuery(event.target.value);
                    if (!isLocationDropdownOpen) {
                        setLocationDropdownOpen(true);
                    }
                }}
            />
            <div className="selected-location-error">
                {locationDropdownError}
            </div>
            <RoomLocations
                className={`${
                    isLocationDropdownOpen
                        ? "location-dropdown-show"
                        : "location-dropdown-hide"
                }`}
                clickedLocation={(
                    ids: number[],
                    name: string,
                    closeDropDown?: boolean
                ) => {
                    clickedLocation(ids, name, closeDropDown);
                    if (name) {
                        setLocationDropdownError("");
                    }
                }}
                home_location_id={userData.home_location_id}
                clickedFloor={clickedFloor}
                searchText={locationQuery}
            />
        </div>
    );
}

export default LocationDropdown;
